<script>
export let color = "#000000"
</script>
 <svg {...$$restProps} on:click on:mouseover on:mouseenter on:mouseleave on:keydown on:focus         style="fill:none"         version="1.1"         viewBox="0 0 100 100"         height="100"         width="100">         <polygon style="fill:{color};fill-opacity:1" points="50,0 0,100 100,100" /> </svg> 